import React from "react";

export default function PracticeAreas() {
  return (
    <section className="practice-areas" dir="rtl" aria-labelledby="areas-title">
      <style>{`
        :root{
          --accent:#1f6f3a;
          --muted:#5b6b5b;
          --card-bg:#fff;
          --shadow:0 6px 18px rgba(15,23,15,0.06);
        }
        .practice-areas{
          padding:100px 20px;
          background:linear-gradient(180deg, rgba(47,63,47,0.03), rgba(255,255,255,0));
          font-family:"Noto Sans Arabic", Arial, sans-serif;
          text-align:center;
        }
        .practice-areas__container{
          max-width:1100px;
          margin:0 auto;
        }
        .practice-areas__title{
          font-size:30px;
          font-weight:700;
          color:#0b2e13;
          position:relative;
          display:inline-block;
          margin-bottom:60px;
        }
        .practice-areas__title::before,
        .practice-areas__title::after{
          content:'';
          position:absolute;
          top:50%;
          width:30px;
          height:2px;
          background-color:var(--accent);
        }
        .practice-areas__title::before{
          right:100%;
          margin-right:15px;
        }
        .practice-areas__title::after{
          left:100%;
          margin-left:15px;
        }

        .areas-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit, minmax(230px, 1fr));
          gap:24px;
        }
        .area-card{
          background:var(--card-bg);
          border-radius:14px;
          padding:28px 18px;
          box-shadow:var(--shadow);
          transition:all .25s ease;
          text-align:center;
        }
        .area-card:hover{
          transform:translateY(-6px);
          box-shadow:0 10px 24px rgba(15,23,15,0.1);
        }
        .area-icon{
          width:48px;
          height:48px;
          margin:0 auto 14px;
          border-radius:50%;
          background:rgba(31,111,58,0.08);
          display:grid;
          place-items:center;
          color:var(--accent);
        }
        .area-title{
          font-size:16px;
          font-weight:600;
          color:#143414;
          margin:0;
        }

        @media (max-width:520px){
          .practice-areas__title{font-size:26px;}
        }
      `}</style>

      <div className="practice-areas__container">
        <h2 id="areas-title" className="practice-areas__title">
          التخصصات القانونية
        </h2>

        <div className="areas-grid">
          {[
            "قضايا مدنية",
            "قضايا جنائية",
            "قضايا أحوال شخصية",
            "قضايا عمالية",
            "قضايا التأمينات والمعاشات",
            "تأسيس الشركات",
            "قضاء إداري ومجلس الدولة",
          ].map((area, i) => (
            <div key={i} className="area-card">
              <div className="area-icon" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2l9 4-9 4-9-4 9-4z" />
                  <path d="M3 6v6c0 5 4 9 9 9s9-4 9-9V6" />
                </svg>
              </div>
              <h3 className="area-title">{area}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
